import { ServicePort, VirtualCircuit } from "./models/types";

export class ModifyLightPath {
  // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
  protected remote_port_shutdown: boolean;
  // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
  protected speed_policer: boolean;
  // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
  private service_ports: ServicePort[];

  get payload(): object {
    return {
      service_ports: this.service_ports,
      remote_port_shutdown: this.remote_port_shutdown,
      speed_policer: this.speed_policer,
    };
  }

  set speedPolicer(val: boolean) {
    this.speed_policer = val;
  }

  set remotePortShutdown(val: boolean) {
    this.remote_port_shutdown = val;
  }

  set subscription(sub: any) {
    const circuits = sub.circuits || sub._circuits;
    this.speed_policer = sub.speedPolicer;
    this.remote_port_shutdown = circuits[0].remotePortShutdown;

    this.service_ports = circuits[0].endpoints.map(
      (endpoint) =>
        ({
          subscription_id: endpoint.port.subscriptionId,
          vlan: endpoint.vlanrange,
        }) as ServicePort,
    );
  }

  updateCircuit(_index: number, ports: ServicePort[]) {
    this.service_ports = ports;
  }

  check() {
    return this.service_ports.length === 2;
  }
}

export class ModifyRedundantLightPath extends ModifyLightPath {
  // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
  private virtual_circuits: VirtualCircuit[];

  get payload() {
    return {
      virtual_circuits: this.virtual_circuits,
      remote_port_shutdown: this.remote_port_shutdown,
      speed_policer: this.speed_policer,
    };
  }

  set subscription(sub: any) {
    const circuits = sub.circuits || sub._circuits;
    this.speed_policer = circuits[0].speedPolicer;
    this.remote_port_shutdown = circuits[0].remotePortShutdown;

    this.virtual_circuits = circuits.map((circuit) => ({
      service_ports: circuit.endpoints.map(
        (endpoint) =>
          ({
            subscription_id: endpoint.port.subscriptionId,
            vlan: endpoint.vlanrange,
          }) as ServicePort,
      ),
    }));
  }
  updateCircuit(index: number, ports: ServicePort[]) {
    this.virtual_circuits[index].service_ports = ports;
  }
}
